import React, { useEffect } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";

function Support() {

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    }, []);

  return (
    <div>
   <section className="home-support" style={{overflowX:"hidden"}}>
  <div
    className="home-support-outer"
    style={{ backgroundImage: "url(assets/images/img13.jpg)" }}
  >
    <div className="overlay" />
    <div className="container">
      <div className="section-head text-center">
        <div className="row">
          <div className="col-lg-8 offset-lg-2" Data-aos="fade-up">
            <div className="title-divider" />
            <h2 className="section-title">Our Flawless Process</h2>
            {/* <p>
              We follow a clear and proven workflow that ensures quality, 
              efficiency, and successful project delivery from start to finish.
            </p> */}
          </div>
        </div>
      </div>

      <div className="support-inner text-center">
        <div className="row" >
          <div className="col-md-3 col-sm-6" data-aos="fade-right" data-aos-delay="250">
            <div className="support-icon-item">
            <a >
                <i aria-hidden="true" className="icon icon-page_search" />
                <h4>Research</h4>
                {/* <p>In-depth analysis to understand your business needs.</p> */}
              </a>
            </div>
          </div>

          <div className="col-md-3 col-sm-6" data-aos="fade-right" data-aos-delay="200">
            <div className="support-icon-item">
              <a >
                <i aria-hidden="true" className="icon icon-atomic" />
                <h4>Develop</h4>
                {/* <p>Building tailored solutions with the latest technology.</p> */}
              </a>
            </div>
          </div>

          <div className="col-md-3 col-sm-6" data-aos="fade-left" data-aos-delay="200">
            <div className="support-icon-item">
              <a >
                <i aria-hidden="true" className="icon icon-settings1" />
                <h4>Testing</h4>
                {/* <p>Rigorous QA to ensure reliability and performance.</p> */}
              </a>
            </div>
          </div>

          <div className="col-md-3 col-sm-6" data-aos="fade-left" data-aos-delay="250">
            <div className="support-icon-item">
              <a >
                <i aria-hidden="true" className="icon icon-checked1" />
                <h4>Launch</h4>
                {/* <p>Seamless deployment to get your product live faster.</p> */}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  {/* Support Section */}
  <div className="container">
    <div className="home-support-details">
      <div
        className="home-support-image"
        style={{ backgroundImage: "url(assets/images/img8.jpg)" }}
      ></div>
      <div className="home-support-content">
        <div className="title-divider mb-4 pb-4" />
        <h3>Looking for the best support for your business growth?</h3>
        {/* <div className="support-btn-wrap d-flex flex-wrap align-items-center justify-content-between">
          <a href="contact.html" className="button-round">
            Free Consultation
          </a>
          <div className="d-flex flex-wrap">
            <div className="support-number-icon">
              <i aria-hidden="true" className="icon icon-phone" />
            </div>
            <div className="support-number-content">
              <h5>Available 24/7</h5>
              <a href="tel:+91125927357">+(911) 259 273 57</a>
            </div>
          </div>
        </div> */}
        <div Data-aos="fade-up">
        <a href="/contact" className="button-round">
          Click here
          </a>
        </div>
      </div>
    </div>
  </div>
</section>


    </div>
  )
}

export default Support
